<template>
  <div id="exam" class="container p-3">
    <div class="row" v-if="examData.parts">
      <div class="col-sm-12 pt-2 pb-3">
        <span style="font-size: 1.5em;">{{ examData.parts[partNum].isListening ? 'Listening Test' : 'Reading Test' }}</span>
      </div>
    </div>

    <div class="row questions" v-for="(part, partIndex) in examData.parts" :key="partIndex" v-if="partIndex == partNum">
      <div class="card pl-0 pr-0 text-left" v-bind:class="{ 'col-sm-12': !twoCols, 'col-sm-6': twoCols }">
        <div class="card-header">
          <div class="row">
            <div class="col-md-12">
              {{ part.name }}
              <span class="float-right" v-if="questNum > 0"> Questions:
                {{ part.questions[questNum - 1].questionType === 'Package' ?
                  part.questions[questNum - 1].childs[0].num :
                  part.questions[questNum - 1].num }} / {{ questionCounts }}
              </span>
            </div>

            <div class="col-sm-6 text-left">
              {{ part.questionCount }} questions in total
            </div>

            <div class="col-sm-6 text-right">
              <span class="mr-1" v-if="questionTimer && questionTimer >= 0">Answer time: <img src="../assets/images/btn_text_slow_on.png" /> {{ duration(questionTimer) }}</span>
              Total time: <img src="../assets/images/btn_text_slow_on.png" /> <span :class="{ 'text-danger': timer <= 900 }">{{ duration(timer) }}</span>
            </div>
          </div>
        </div>

        <div class="card-body" v-if="questNum === 0">
          <span @click="play(currentPart.descriptionAudioUrl)"
              v-on:mouseover="speakerHover = true"
              v-on:mouseout="speakerHover = false"
              v-if="currentPart.descriptionAudioUrl && isMobileDevice">
            <img class="btn-click" src="../assets/images/btn_play_sound_off.png" v-if="!speakerHover" />
            <img class="btn-click" src="../assets/images/btn_play_sound_on.png" v-else />
          </span>
          <p v-html="part.description"></p>
        </div>

        <div class="card-body"
          v-for="(question, questIndex) in part.questions"
          :key="questIndex"
          v-if="questNum === questIndex + 1">
          <div v-if="question.questionType === 'MultiChoice'"
            is="MultiChoice"
            :question="question"
            :selected="selectedAnswer(question.id)"
            :canAudioReplay="(isMobileDevice || examData.parts[partNum].endDelay === null)"
            v-on:answer="handleAnswer"></div>

          <div v-if="question.questionType === 'Package'" class="row" style="height: 100%;">
            <div class="col-sm-6" style="height: 100%; overflow-y: scroll;">
              <p>
                {{ question.num ? question.num + '. ' : '' }}
                <span @click="play(question.audio)"
                  v-on:mouseover="speakerHover = true"
                  v-on:mouseout="speakerHover = false"
                  v-if="question.audio && (isMobileDevice || examData.parts[partNum].endDelay === null)">
                  <img class="btn-click" src="../assets/images/btn_play_sound_off.png" v-if="!speakerHover" />
                  <img class="btn-click" src="../assets/images/btn_play_sound_on.png" v-else />
                </span>
              </p>
              <p v-if="question.image">
                <img :src="question.image" width="100%" />
              </p>
              <p v-if="question.title" class="pre" v-html="question.title"></p>
            </div>

            <div class="col-sm-6" style="height: 100%; overflow-y: scroll;">
              <div v-for="(childQuestion, qcindex) in question.childs"
                 :key="qcindex"
                 class="pb-2 pt-2"
                 is="MultiChoice"
                 :question="childQuestion"
                 :selected="selectedAnswer(childQuestion.id)"
                 v-if="childQuestion.questionType === 'MultiChoice'"
                 v-on:answer="handleAnswer">
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer text-sm-center" v-if="examData.parts[partNum].endDelay === null">
          <a class="btn btn-primary" @click="prev()" v-if="!(partIndex === 0 && questNum === 0)">Previous</a>
          <a class="btn btn-primary ml-1" @click="next()">
            {{ (partIndex === examData.parts.length - 1 && part.questions.length === questNum) ? 'Finish' : 'Next' }}
          </a>
        </div>
      </div>

      <div class="card col-sm-5 ml-3 answer-sheet" v-if="twoCols">
        <div class="card-header">&nbsp;</div>
        <div class="card-body">
          <ul class="list-group">
            <li class="list-group-item" v-for="n in 10" :key="n">
              <span>{{ n }}. </span>
              <Options v-on:answer="handleAnswer"></Options>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MultiChoice from './modules/MultiChoice.vue'
  import timerMixin from './mixins/timerMixin.js'
  import toolMixin from './mixins/toolMixin.js'
  import MobileDetect from 'mobile-detect'
  import api from '../api.js'
  import langMixin from '../../langMixin'
  import { mapActions } from 'vuex'

  export default {

    name: 'Exam',

    components: {
      MultiChoice
    },

    mixins: [timerMixin, toolMixin, langMixin],

    props: {
      liveData: {
        type: Object,
        required: true,
        default: () => {
          return {}
        }
      },

      folderPath: {
        type: String,
        required: false,
        default: ''
      }
    },

    data () {
      return {
        answerSheet: [],
        twoCols: false,
        timer: 0,
        examData: [],
        audio: null,
        partNum: 0,
        questNum: 0,
        questionCounts: 0,
        userAnswers: [],
        answerPool: [],
        uplaodAnswerRetry: 3,
        questionTmpTimer: 0,
        packageQuestionAudioIndex: 0,
        packageQuestionAudioTmpIndex: 0,
        isMobileDevice: false,
        isFinish: false,
        isQuestEnd: false,
        speakerHover: false,
        score: {
          listening: 0,
          reading: 0,
          total: 0
        }
      }
    },

    computed: {
      currentPart () {
        return this.examData.parts[this.partNum]
      },

      currentQuestion () {
        return (this.questNum > 0) ? this.examData.parts[this.partNum].questions[this.questNum - 1] : {}
      },

      questionTimer () {
        if (!(this.examData.parts[this.partNum].isListening && this.questionTmpTimer > 0)) {
          return false
        }

        if (this.examData.parts[this.partNum].endDelay === null) {
          return false
        }

        let sec = this.examData.parts[this.partNum].endDelay - (this.questionTmpTimer - this.timer)

        if (this.currentQuestion.questionType === 'Package') {
          if (this.packageQuestionAudioIndex === this.packageQuestionAudioTmpIndex) {
            // eslint-disable-next-line
            this.questionTmpTimer = 0
            // eslint-disable-next-line
            this.packageQuestionAudioTmpIndex += 1
            this.play(this.currentQuestion.childs[this.packageQuestionAudioIndex].audio)
          } else {
            if (sec < 0) {
              // eslint-disable-next-line
              this.packageQuestionAudioIndex += 1

              if (this.packageQuestionAudioIndex >= this.currentQuestion.childs.length) {
                this.next()
                // eslint-disable-next-line
                this.packageQuestionAudioIndex = 0
                // eslint-disable-next-line
                this.packageQuestionAudioTmpIndex = 0
              }
            }

            return sec
          }
        } else {
          if (sec < 0) {
            this.next()
          }

          return sec
        }
      }
    },

    created () {
      let md = new MobileDetect(window.navigator.userAgent)
      if (md.os() === 'AndroidOS' || md.os() === 'iOS') {
        this.isMobileDevice = true
      }
    },

    mounted () {
      if (Object.keys(this.liveData).length > 0) {
        this.dataParsing(this.liveData, this.folderPath)
        this.start(this.liveData)
      }
    },

    destroyed () {
      this.audio && this.audio.pause()
    },

    beforeRouteLeave (to, from, next) {
      if (!this.isFinish) {
        const answer = window.confirm('The exam is not over yet. Are you sure you want to leave the exam?')
        if (answer) {
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    },

    methods: {
      ...mapActions(['postAnswers']),

      start (data) {
        let self = this
        this.examData = this.jsonDataParsingRuby(data)
        this.examData.parts[this.partNum].descriptionAudioUrl && this.play(this.examData.parts[this.partNum].descriptionAudioUrl)

        this.examData.parts.forEach((part) => {
          self.questionCounts += part.questionCount
        })

        let examMins = this.examData.examMinutes || 60

        this.startCountDown(examMins * 60, (timer) => {
          self.timer = timer

          if (self.timer <= 0) {
            self.finish()
          }
        })
      },

      handleAnswer (answer) {
        let idx = this.answerPool.map((e) => { return e.id }).indexOf(answer.id)
        idx > -1 && this.answerPool.splice(idx, 1)
        this.answerPool.push(answer)
        // window.console.log('handleAnswer', JSON.stringify(this.answerPool))

        let pidx = this.userAnswers.map((e) => { return e.id }).indexOf(answer.id)
        pidx > -1 && this.userAnswers.splice(pidx, 1)
        this.userAnswers.push(answer)
      },

      play (url) {
        this.audio && this.audio.pause()
        this.audio = new window.Audio(url)

        let self = this

        this.audio.onended = () => {
          this.audio = null
          if (self.questNum === 0) {
            self.next()
          } else {
            self.questionTmpTimer = self.timer
          }
        }
        this.audio.play()
      },

      next () {
        this.questionTmpTimer = 0
        this.audio && this.audio.pause()
        this.isQuestEnd = false

        if (this.examData.parts[this.partNum].questions && this.questNum < this.examData.parts[this.partNum].questions.length) {
          this.questNum += 1

          this.currentQuestion.audio && this.play(this.currentQuestion.audio)
        } else if (this.partNum < this.examData.parts.length - 1) {
          this.partNum += 1
          this.questNum = 0

          this.currentPart.descriptionAudioUrl && this.play(this.currentPart.descriptionAudioUrl)
        } else {
          this.isQuestEnd = true

          if (this.answerPool.length === 0) {
            this.finish()
          } else {
            this.uploadAnswer(this.finish)
          }

          return
        }
        this.uploadAnswer()
      },

      prev () {
        this.questionTmpTimer = 0
        this.audio && this.audio.pause()
        this.isQuestEnd = false

        if (this.questNum > 0) {
          this.questNum -= 1

          this.currentQuestion.audio && this.play(this.currentQuestion.audio)
        } else if (this.partNum > 0) {
          this.partNum -= 1
          this.questNum = this.examData.parts[this.partNum].questions.length

          this.currentPart.descriptionAudioUrl && this.play(this.currentPart.descriptionAudioUrl)
        }
      },

      async uploadAnswer (callback = undefined) {
        if (this.answerPool.length > 0) {
          let queue = [].concat(this.answerPool)
          // window.console.log(JSON.stringify(this.answerPool))

          try {
            const { data } = await this.handlerAnswerData(queue)

            if (data.status === 'OK') {
              this.answerPool = this.answerPool.filter((el) => {
                return queue.map((e) => { return e.id }).indexOf(el.id) < 0
              })

              this.uplaodAnswerRetry = 3
              typeof callback === 'function' && callback()
            }
          } catch (err) {
            if (this.uplaodAnswerRetry > 0 && window.confirm('Answers submit error, retry?')) {
              this.uplaodAnswerRetry -= 1
              this.uploadAnswer()
            } else {
              window.alert('There are multiple transmission errors on the network. Please check your network settings.')
            }
          }
        } else {
          window.console.log('No answer in queue.')
        }
      },

      finish () {
        if (this.isFinish) {
          window.console.log('exam already finished.')
          return
        }

        window.console.log('exam finish.')
        this.handlerFinishData()
      },

      selectedAnswer (qid) {
        let idx = this.userAnswers.map((e) => { return e.id }).indexOf(qid)
        if (idx > -1) {
          return this.userAnswers[idx]
        } else {
          return {}
        }
      },

      handlerAnswerData (answers, status = 'custom') {
        if (status === 'online') {
          return api.Exam.Answer(this.examData.recordId, answers)
        } else if (status === 'local') {
          let data = {
            status: 'OK',
            answers: answers
          }

          return { data }
        } else if (status === 'custom') {
          return this.postAnswers({
            id: this.examData.recordId,
            answers: answers
          })
        }
      },

      async handlerFinishData (status = 'custom') {
        if (status === 'online') {
          const { data } = await api.Exam.Finish(this.examData.recordId)
          this.isFinish = true

          if (data) {
            this.$router.push({
              name: 'exam-result',
              params: {
                recordId: this.examData.recordId
              }
            })
          }
        } else if (status === 'local') {
          window.console.log('handlerFinishData')
          this.calcScore()
          this.$emit('finish', {
            listening: this.score.listening,
            reading: this.score.reading,
            total: this.score.total,
            userAnswers: this.userAnswers
          })
        } else if (status === 'custom') {
          this.$emit('finish', this.examData.recordId)
        }
      },

      calcScore () {
        let partNum = 0
        let questNum = 0
        let listening = {
          correctNum: 0,
          wrongNum: 0
        }
        let reading = {
          correctNum: 0,
          wrongNum: 0
        }
        let end = false
        let examData = this.examData
        let userAnswers = this.userAnswers

        while (!end) {
          if (examData.parts[partNum].questions && questNum <= examData.parts[partNum].questions.length) {
            let currentQuestion = questNum > 0 ? examData.parts[partNum].questions[questNum - 1] : null
            if (currentQuestion) {
              if (currentQuestion.questionType === 'Package' && currentQuestion.childs) {
                for (let i = currentQuestion.childs.length - 1; i >= 0; i--) {
                  let idx = userAnswers.map((e) => { return e.id }).indexOf(currentQuestion.childs[i].id)

                  if (idx > -1) {
                    userAnswers[idx].answer = currentQuestion.childs[i].answer
                  }

                  if (idx > -1 && userAnswers[idx].answers[0].key === currentQuestion.childs[i].answer) {
                    examData.parts[partNum].isListening ? listening.correctNum += 1 : reading.correctNum += 1
                  } else {
                    examData.parts[partNum].isListening ? listening.wrongNum += 1 : reading.wrongNum += 1
                  }
                }
              } else {
                let idx = userAnswers.map((e) => { return e.id }).indexOf(currentQuestion.id)

                if (idx > -1) {
                  userAnswers[idx].answer = currentQuestion.answer
                }

                if (idx > -1 && userAnswers[idx].answers[0].key === currentQuestion.answer) {
                  examData.parts[partNum].isListening ? listening.correctNum += 1 : reading.correctNum += 1
                } else {
                  examData.parts[partNum].isListening ? listening.wrongNum += 1 : reading.wrongNum += 1
                }
              }
            }

            questNum += 1
          } else if (partNum < examData.parts.length - 1) {
            partNum += 1
            questNum = 0
          } else {
            end = true
          }
        }

        // let score = 0
        this.score.listening = parseInt(this.getToeicScore('listen', listening.correctNum, 200))
        this.score.reading = parseInt(this.getToeicScore('read', reading.correctNum, 200))
        this.score.total = this.score.listening + this.score.reading
        // window.console.log(this.getToeicScore('listen', listening.correctNum, 200), this.getToeicScore('read', reading.correctNum, 200), score)
      },

      getToeicScore (type, right, total = 100) {
        let listenMaps = [ 5, 5, 5, 5, 5, 5, 5, 10, 10, 10, 15, 15, 20, 25, 30, 35, 40, 50, 55, 60, 65, 70, 75, 80, 90, 95, 100, 105, 110, 120, 125, 130, 135, 140, 150, 155, 160, 165, 170, 180, 185, 190, 195, 200, 210, 215, 220, 225, 230, 240, 245, 250, 255, 260, 270, 275, 280, 285, 290, 300, 305, 310, 315, 320, 330, 335, 340, 345, 350, 355, 360, 365, 370, 375, 385, 390, 395, 400, 405, 410, 415, 420, 425, 430, 440, 445, 450, 455, 460, 470, 475, 480, 480, 485, 485, 485, 490, 490, 490, 495, 495 ]
        let readMaps = [ 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 10, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 155, 160, 165, 170, 175, 180, 185, 190, 195, 200, 210, 215, 220, 225, 230, 235, 240, 245, 250, 255, 260, 270, 275, 280, 285, 290, 295, 300, 305, 310, 320, 325, 330, 335, 340, 350, 355, 360, 365, 370, 375, 380, 385, 390, 400, 405, 410, 415, 420, 425, 430, 435, 440, 445, 450, 460, 465, 470, 475, 480, 485, 495 ]

        right = Math.floor(right * (100 / total))

        if (type.toLowerCase() === 'read') {
          return readMaps[right]
        } else {
          return listenMaps[right]
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/style/app.scss";

  #exam {
    min-width: 480px !important;
  }

  .questions {
    .card-body {
      height: 60vh;
      overflow-y: scroll;
    }

    .answer-sheet {
      height: 100%;
      overflow-y: auto;
    }
  }

  .card {
    background-color: #fff;
    padding: 0;
  }

  .card-header,
  .card-footer {
    background-color: #fff;
  }

  u {
    position: relative;
    text-decoration: none;
  }

  u:before {
    content: "";
    width: 100%;
    border-bottom: 1px solid black;
    height: 100%;
    position: absolute;
  }

  .pre {
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// Exam.vue?a1c0bfd2